<template>
  <!-- Profile Info Tab -->
  <div id="emp_profile" class="pro-overview tab-pane fade show active">
    <div class="row g-3">
      <div class="col-lg-12 col-xl-6 d-flex flex-column gap-3">
        <div class="pp-card ">
          <div class="pp-header justify-content-start">
            <div class="pp-header-icon"><i class="fa-solid fa-user-large" aria-hidden="true"></i></div>
            <h3 class="pp-title">Personal Information</h3>
            <!-- <div class="pp-header-edit-icon">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.47079 2.47059H1.55556C0.696449 2.47059 0 3.208 0 4.11765V12.3529C0 13.2626 0.696449 14 1.55556 14H10.1112C10.9703 14 11.6667 13.2626 11.6667 12.3529V6.32502L8.62269 9.54813C8.35124 9.83554 8.00551 10.0315 7.62909 10.1112L5.54376 10.5528C4.18319 10.8409 2.98362 9.57076 3.25573 8.13016L3.6728 5.92218C3.74808 5.52361 3.93311 5.15756 4.20455 4.87015L6.47079 2.47059Z"
                  fill="#0C090A" fill-opacity="0.66" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M13.1028 1.02541C13.0239 0.823914 12.9083 0.640843 12.7626 0.486661C12.617 0.332377 12.4441 0.209987 12.2538 0.126483C12.0635 0.0429798 11.8595 0 11.6535 0C11.4475 0 11.2435 0.0429798 11.0532 0.126483C10.8629 0.209987 10.69 0.332377 10.5444 0.486661L10.1198 0.93621L12.338 3.28492L12.7626 2.83537C12.9083 2.68119 13.0239 2.49811 13.1028 2.29661C13.1816 2.09511 13.2222 1.87913 13.2222 1.66101C13.2222 1.4429 13.1816 1.22692 13.1028 1.02541ZM11.2381 4.44956L9.01985 2.10086L5.30449 6.03479C5.2502 6.09227 5.2132 6.16548 5.19814 6.24519L4.78108 8.45317C4.72665 8.74129 4.96657 8.99532 5.23868 8.93769L7.324 8.4961C7.39929 8.48015 7.46843 8.44097 7.52272 8.38349L11.2381 4.44956Z"
                  fill="#0C090A" fill-opacity="0.66" />
              </svg>
            </div> -->
            
          </div>
          <div class="pp-body">
            <ul class="employee-personal-info">
              <li>
                <div class="title">Salutation</div>
                <div class="text">
                  {{ personalInformation.salutation_name }}
                </div>
              </li>
              <li>
                <div class="title">Full Name</div>
                <div class="text">
                  {{
                    personalInformation.first_name
                      ? ` ${personalInformation.first_name}`
                      : ""
                  }}{{
                    personalInformation.middle_name
                      ? ` ${personalInformation.middle_name}`
                      : ""
                  }}
                  {{
                    personalInformation.last_name
                      ? ` ${personalInformation.last_name}`
                      : ""
                  }}
                </div>
              </li>
              <li>
                <div class="title">Father/Husband Name</div>
                <div class="text">
                  {{
                    personalInformation.husband_father_name != null
                      ? personalInformation.husband_father_name
                      : "N/A"
                  }}
                </div>
              </li>
              <li>
                <div class="title">CNIC</div>
                <div class="text">{{ personalInformation.cnic_number }}</div>
              </li>
              <li>
                <div class="title">Expiry Date</div>
                <div class="text">{{ personalInformation.cnic_exp_date }}</div>
              </li>
              <li>
                <div class="title">Email</div>
                <div class="text text-email">
                  {{ personalInformation.personal_email_address }}
                </div>
              </li>
              <li>
                <div class="title">DOB</div>
                <div class="text">{{ personalInformation.dob }}</div>
              </li>
              <li>
                <div class="title">City</div>
                <div class="text">{{ personalInformation.city_name }}</div>
              </li>
              <li>
                <div class="title">Country</div>
                <div class="text">{{ personalInformation.country_name }}</div>
              </li>
              <li>
                <div class="title">Marital status</div>
                <div class="text">{{ personalInformation.marital_status }}</div>
              </li>
              <li>
                <div class="title">Religion</div>
                <div class="text">{{ personalInformation.religion_name }}</div>
              </li>
              <li>
                <div class="title">Gender</div>
                <div class="text">{{ personalInformation.gender_name }}</div>
              </li>
              <li>
                <div class="title">Nationality</div>
                <div class="text">
                  {{ personalInformation.nationality_name }}
                </div>
              </li>
              <li>
                <div class="title">Blood Group</div>
                <div class="text">
                  {{ personalInformation.blood_group_name }}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="pp-card ">
          <div class="pp-header justify-content-start">
            <div class="pp-header-icon"><i class="fa-solid fa-briefcase" aria-hidden="true"></i></div>
            <h3 class="pp-title">Positional Information</h3>
            <!-- <div class="pp-header-edit-icon">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.47079 2.47059H1.55556C0.696449 2.47059 0 3.208 0 4.11765V12.3529C0 13.2626 0.696449 14 1.55556 14H10.1112C10.9703 14 11.6667 13.2626 11.6667 12.3529V6.32502L8.62269 9.54813C8.35124 9.83554 8.00551 10.0315 7.62909 10.1112L5.54376 10.5528C4.18319 10.8409 2.98362 9.57076 3.25573 8.13016L3.6728 5.92218C3.74808 5.52361 3.93311 5.15756 4.20455 4.87015L6.47079 2.47059Z"
                  fill="#0C090A" fill-opacity="0.66" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M13.1028 1.02541C13.0239 0.823914 12.9083 0.640843 12.7626 0.486661C12.617 0.332377 12.4441 0.209987 12.2538 0.126483C12.0635 0.0429798 11.8595 0 11.6535 0C11.4475 0 11.2435 0.0429798 11.0532 0.126483C10.8629 0.209987 10.69 0.332377 10.5444 0.486661L10.1198 0.93621L12.338 3.28492L12.7626 2.83537C12.9083 2.68119 13.0239 2.49811 13.1028 2.29661C13.1816 2.09511 13.2222 1.87913 13.2222 1.66101C13.2222 1.4429 13.1816 1.22692 13.1028 1.02541ZM11.2381 4.44956L9.01985 2.10086L5.30449 6.03479C5.2502 6.09227 5.2132 6.16548 5.19814 6.24519L4.78108 8.45317C4.72665 8.74129 4.96657 8.99532 5.23868 8.93769L7.324 8.4961C7.39929 8.48015 7.46843 8.44097 7.52272 8.38349L11.2381 4.44956Z"
                  fill="#0C090A" fill-opacity="0.66" />
              </svg>
            </div> -->
          </div>
          <div class="pp-body">
            <ul class="employee-personal-info">
              <li>
                <div class="title">Employee ID</div>
                <div class="text">{{ positionalInformation.hcm_id }}</div>
              </li>
              <li>
                <div class="title">Machine ID</div>
                <div class="text">{{ positionalInformation.machine_uid || 'N/A'}}</div>
              </li>
              <li>
                <div class="title">Pseudo Name</div>
                <div class="text">{{ positionalInformation.pseudo_name != null ? positionalInformation.pseudo_name :
                  "N/A" }}</div>
              </li>
              <li>
                <div class="title">Business Email</div>
                <div class="text text-email">{{ positionalInformation.business_email }}</div>
              </li>
              <li>
                <div class="title">Employee Status</div>
                <div class="text">{{ positionalInformation.status_name != null ? positionalInformation.status_name :
                  "N/A" }}</div>
              </li>
              <li>
                <div class="title">Duty Type</div>
                <div class="text">{{ positionalInformation.employee_duty_type_name || "N/A" }}</div>
              </li>
              <li>
                <div class="title">Employment Level</div>
                <div class="text">{{ employmentLevel.level || "N/A" }}</div>
              </li>
              <li>
                <div class="title">Employee Grade</div>
                <div class="text">{{ employmentLevel.level }}{{ employmentLevel.level && employmentGrade.grade ? "-" :
                  "" }}{{ employmentGrade.grade }}</div>
              </li>
              <li>
                <div class="title">Contract Duration</div>
                <div class="text" v-if="positionalInformation.status_name == 'contractual'">{{
                  contractDetails.contract_from }} - {{ contractDetails.contract_to }}</div>
                <div class="text" v-else>N/A</div>
              </li>
              <li>
                <div class="title">Shift Timing</div>
                <div class="text">{{ positionalInformation.shift_name }}</div>
              </li>
              <li>
                <div class="title">Designation</div>
                <div class="text">{{ positionalInformation.designation_name }}</div>
              </li>
              <li>
                <div class="title">Division</div>
                <div class="text">{{ positionalInformation.division_name }}</div>
              </li>
              <li>
                <div class="title">Department</div>
                <div class="text">{{ positionalInformation.department_name }}</div>
              </li>
              <li>
                <div class="title">Client</div>
                <div class="text">{{ positionalInformation.client_name || 'N/A' }}</div>
              </li>
              <li>
                <div class="title">Section</div>
                <div class="text">{{ positionalInformation.section_name || 'N/A' }}</div>
              </li>
              <li>
                <div class="title">Project</div>
                <div class="text">{{ positionalInformation.employee_project_name || 'N/A' }}</div>
              </li>
              <li>
                <div class="title">Team</div>
                <div class="text">{{ positionalInformation.team_name || 'N/A'}}</div>
              </li>
              <li>
                <div class="title">Campaign</div>
                <div class="text">{{ positionalInformation.campaigns || 'N/A' }}</div>
              </li>
              <li>
                <div class="title">Probation Start Date</div>
                <div class="text">{{ positionalInformation.probation_start_date || 'N/A' }}</div>
              </li>
              <li>
                <div class="title">Probation Ending Date</div>
                <div class="text">{{ positionalInformation.probation_ending_date || 'N/A' }}</div>
              </li>
              <li>
                <div class="title">Probation Duration</div>
                <div class="text">{{ `${positionalInformation.probation_duration_month} month${positionalInformation.probation_duration_month !== 1 ? 's' : ''}` || 'N/A' }}</div>
              </li>
              <li>
                <div class="title">Confirmation date (Effective Till)</div>
                <div class="text">{{ positionalInformation.date_of_confirmation || 'N/A' }}</div>
              </li>
              <li>
                <div class="title">Remote work</div>
                <div class="text">{{ positionalInformation.wfh || 'N/A' }}</div>
              </li>
              <li>
                <div class="title">Original Date of Joining</div>
                <div class="text">{{ positionalInformation.hiring_date || 'N/A' }}</div>
              </li>
              <li>
                <div class="title">Date of Joining</div>
                <div class="text">{{ positionalInformation.joining_date || 'N/A' }}</div>
              </li>
              <li>
                <div class="title">Date of Separation</div>
                <div class="text">{{ positionalInformation.date_of_separation || "N/A" }}</div>
              </li>
              <li>
                <div class="title">Reporting Authority</div>
                <div class="text">{{ positionalInformation.reporting_authority != null ?
                  positionalInformation.reporting_authority_name : "N/A" }}</div>
              </li>
              <li>
                <div class="title">Indirect Reporting Authority</div>
                <div class="text">{{ positionalInformation.indirect_authority != null ?
                  positionalInformation.indirect_authority_name : "N/A" }}</div>
              </li>
              <li>
                <div class="title">Team Authority</div>
                <div class="text">{{ positionalInformation.team_reporting ? "Yes" : "No" }}</div>
              </li>
              <li>
                <div class="title">Mobile Access</div>
                <div class="text">{{ positionalInformation.has_mobile_access ? "Yes" : "No" }}</div>
              </li>
              <li>
                <div class="title">Geofencing</div>
                <div class="text">{{ positionalInformation.has_geofence ? "Yes" : "No" }}</div>
              </li>
              <li>
                <div class="title">Reason of Separation</div>
                <div class="text">{{ positionalInformation.resign_reason != null ? positionalInformation.resign_reason : "N/A" }}</div>
              </li>
              <li>
                <div class="title">Comments</div>
                <div class="text">
                  <a v-if="positionalInformation.comments" href="javascript:void(0);" data-bs-toggle="modal"
                    data-bs-target="#separation_comments_modal" title="View comments">
                    <i class="fa-solid fa-eye"></i>
                  </a>
                  <span v-else>N/A</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="pp-card ">
          <div class="pp-header justify-content-start">
            <div class="pp-header-icon"><i class="fa-solid fa-user-tie" aria-hidden="true"></i></div>
            <h3 class="pp-title">Work Experience</h3>
            <!-- <div class="pp-header-edit-icon">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.47079 2.47059H1.55556C0.696449 2.47059 0 3.208 0 4.11765V12.3529C0 13.2626 0.696449 14 1.55556 14H10.1112C10.9703 14 11.6667 13.2626 11.6667 12.3529V6.32502L8.62269 9.54813C8.35124 9.83554 8.00551 10.0315 7.62909 10.1112L5.54376 10.5528C4.18319 10.8409 2.98362 9.57076 3.25573 8.13016L3.6728 5.92218C3.74808 5.52361 3.93311 5.15756 4.20455 4.87015L6.47079 2.47059Z"
                  fill="#0C090A" fill-opacity="0.66" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M13.1028 1.02541C13.0239 0.823914 12.9083 0.640843 12.7626 0.486661C12.617 0.332377 12.4441 0.209987 12.2538 0.126483C12.0635 0.0429798 11.8595 0 11.6535 0C11.4475 0 11.2435 0.0429798 11.0532 0.126483C10.8629 0.209987 10.69 0.332377 10.5444 0.486661L10.1198 0.93621L12.338 3.28492L12.7626 2.83537C12.9083 2.68119 13.0239 2.49811 13.1028 2.29661C13.1816 2.09511 13.2222 1.87913 13.2222 1.66101C13.2222 1.4429 13.1816 1.22692 13.1028 1.02541ZM11.2381 4.44956L9.01985 2.10086L5.30449 6.03479C5.2502 6.09227 5.2132 6.16548 5.19814 6.24519L4.78108 8.45317C4.72665 8.74129 4.96657 8.99532 5.23868 8.93769L7.324 8.4961C7.39929 8.48015 7.46843 8.44097 7.52272 8.38349L11.2381 4.44956Z"
                  fill="#0C090A" fill-opacity="0.66" />
              </svg>
            </div> -->
          </div>
          <div class="pp-body">
            <ul class="employee-personal-info" v-if="workExperience.length > 0">
              <template v-for="work in workExperience" :key="work.id">
                <li>
                  <div class="title">Employer Name</div>
                  <div class="text">{{ work.employer_name || "N/A" }}</div>
                </li>
                <li>
                  <div class="title">Designation</div>
                  <div class="text">{{ work.designation || "N/A" }}</div>
                </li>
                <li>
                  <div class="title">Company Name</div>
                  <div class="text">{{ work.company_name || "N/A" }}</div>
                </li>
                <li>
                  <div class="title">From Date</div>
                  <div class="text">{{ work.period_from || "N/A" }}</div>
                </li>
                <li>
                  <div class="title">To Date</div>
                  <div class="text">{{ work.period_to || "N/A" }}</div>
                </li>
              </template>
            </ul>
            <ul class="employee-personal-info" v-else>
              <li>
                <div class="title">Work Experience</div>
                <div class="text">N/A</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-xl-6 d-flex flex-column gap-3">
        <div class="pp-card ">
          <div class="pp-header justify-content-start">
            <div class="pp-header-icon"><i class="fa-solid fa-phone-volume" aria-hidden="true"></i></div>
            <h3 class="pp-title">Contact Information</h3>
            <!-- <div class="pp-header-edit-icon">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.47079 2.47059H1.55556C0.696449 2.47059 0 3.208 0 4.11765V12.3529C0 13.2626 0.696449 14 1.55556 14H10.1112C10.9703 14 11.6667 13.2626 11.6667 12.3529V6.32502L8.62269 9.54813C8.35124 9.83554 8.00551 10.0315 7.62909 10.1112L5.54376 10.5528C4.18319 10.8409 2.98362 9.57076 3.25573 8.13016L3.6728 5.92218C3.74808 5.52361 3.93311 5.15756 4.20455 4.87015L6.47079 2.47059Z"
                  fill="#0C090A" fill-opacity="0.66" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M13.1028 1.02541C13.0239 0.823914 12.9083 0.640843 12.7626 0.486661C12.617 0.332377 12.4441 0.209987 12.2538 0.126483C12.0635 0.0429798 11.8595 0 11.6535 0C11.4475 0 11.2435 0.0429798 11.0532 0.126483C10.8629 0.209987 10.69 0.332377 10.5444 0.486661L10.1198 0.93621L12.338 3.28492L12.7626 2.83537C12.9083 2.68119 13.0239 2.49811 13.1028 2.29661C13.1816 2.09511 13.2222 1.87913 13.2222 1.66101C13.2222 1.4429 13.1816 1.22692 13.1028 1.02541ZM11.2381 4.44956L9.01985 2.10086L5.30449 6.03479C5.2502 6.09227 5.2132 6.16548 5.19814 6.24519L4.78108 8.45317C4.72665 8.74129 4.96657 8.99532 5.23868 8.93769L7.324 8.4961C7.39929 8.48015 7.46843 8.44097 7.52272 8.38349L11.2381 4.44956Z"
                  fill="#0C090A" fill-opacity="0.66" />
              </svg>
            </div> -->
          </div>
          <div class="pp-body">
            <ul class="employee-personal-info">
              <li>
                <div class="title">Primary Contact Number</div>
                <div class="text">
                  {{ contactInformation.primary_contact_no }}
                </div>
              </li>
              <li>
                <div class="title">Secondary Contact Number</div>
                <div class="text">
                  {{ contactInformation.secondary_contact_no }}
                </div>
              </li>
              <li>
                <div class="title">Landline Number</div>
                <div class="text">{{ contactInformation.landline_no }}</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="pp-card ">
          <div class="pp-header justify-content-start">
            <div class="pp-header-icon"><i class="fa-solid fa-house" aria-hidden="true"></i></div>
            <h3 class="pp-title">Residential Address</h3>
            <!-- <div class="pp-header-edit-icon">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.47079 2.47059H1.55556C0.696449 2.47059 0 3.208 0 4.11765V12.3529C0 13.2626 0.696449 14 1.55556 14H10.1112C10.9703 14 11.6667 13.2626 11.6667 12.3529V6.32502L8.62269 9.54813C8.35124 9.83554 8.00551 10.0315 7.62909 10.1112L5.54376 10.5528C4.18319 10.8409 2.98362 9.57076 3.25573 8.13016L3.6728 5.92218C3.74808 5.52361 3.93311 5.15756 4.20455 4.87015L6.47079 2.47059Z"
                  fill="#0C090A" fill-opacity="0.66" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M13.1028 1.02541C13.0239 0.823914 12.9083 0.640843 12.7626 0.486661C12.617 0.332377 12.4441 0.209987 12.2538 0.126483C12.0635 0.0429798 11.8595 0 11.6535 0C11.4475 0 11.2435 0.0429798 11.0532 0.126483C10.8629 0.209987 10.69 0.332377 10.5444 0.486661L10.1198 0.93621L12.338 3.28492L12.7626 2.83537C12.9083 2.68119 13.0239 2.49811 13.1028 2.29661C13.1816 2.09511 13.2222 1.87913 13.2222 1.66101C13.2222 1.4429 13.1816 1.22692 13.1028 1.02541ZM11.2381 4.44956L9.01985 2.10086L5.30449 6.03479C5.2502 6.09227 5.2132 6.16548 5.19814 6.24519L4.78108 8.45317C4.72665 8.74129 4.96657 8.99532 5.23868 8.93769L7.324 8.4961C7.39929 8.48015 7.46843 8.44097 7.52272 8.38349L11.2381 4.44956Z"
                  fill="#0C090A" fill-opacity="0.66" />
              </svg>
            </div> -->
          </div>
          <div class="pp-body">
            <ul class="employee-personal-info">
              <li>
                <div class="title">Permanent</div>
                <div class="text">
                  {{ contactInformation.permanent_address }}
                </div>
              </li>
              <li>
                <div class="title">Present</div>
                <div class="text">{{ contactInformation.present_address }}</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="pp-card ">
          <div class="pp-header justify-content-start">
            <div class="pp-header-icon"><i class="fa-solid fa-people-roof" aria-hidden="true"></i></div>
            <h3 class="pp-title">Family information</h3>
            <!-- <div class="pp-header-edit-icon">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.47079 2.47059H1.55556C0.696449 2.47059 0 3.208 0 4.11765V12.3529C0 13.2626 0.696449 14 1.55556 14H10.1112C10.9703 14 11.6667 13.2626 11.6667 12.3529V6.32502L8.62269 9.54813C8.35124 9.83554 8.00551 10.0315 7.62909 10.1112L5.54376 10.5528C4.18319 10.8409 2.98362 9.57076 3.25573 8.13016L3.6728 5.92218C3.74808 5.52361 3.93311 5.15756 4.20455 4.87015L6.47079 2.47059Z"
                  fill="#0C090A" fill-opacity="0.66" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M13.1028 1.02541C13.0239 0.823914 12.9083 0.640843 12.7626 0.486661C12.617 0.332377 12.4441 0.209987 12.2538 0.126483C12.0635 0.0429798 11.8595 0 11.6535 0C11.4475 0 11.2435 0.0429798 11.0532 0.126483C10.8629 0.209987 10.69 0.332377 10.5444 0.486661L10.1198 0.93621L12.338 3.28492L12.7626 2.83537C12.9083 2.68119 13.0239 2.49811 13.1028 2.29661C13.1816 2.09511 13.2222 1.87913 13.2222 1.66101C13.2222 1.4429 13.1816 1.22692 13.1028 1.02541ZM11.2381 4.44956L9.01985 2.10086L5.30449 6.03479C5.2502 6.09227 5.2132 6.16548 5.19814 6.24519L4.78108 8.45317C4.72665 8.74129 4.96657 8.99532 5.23868 8.93769L7.324 8.4961C7.39929 8.48015 7.46843 8.44097 7.52272 8.38349L11.2381 4.44956Z"
                  fill="#0C090A" fill-opacity="0.66" />
              </svg>
            </div> -->
          </div>
          <div class="pp-body">
            <ul class="employee-personal-info" v-for="family in familyInformation" :key="family.id">
              <li>
                <div class="title">Spouse Name</div>
                <div class="text">{{ family.spouse_full_name || "N/A" }}</div>
              </li>
              <li>
                <div class="title">Spouse CNIC</div>
                <div class="text">{{ family.spouse_cnic || "N/A" }}</div>
              </li>
              <li>
                <div class="title">Spouse DOB</div>
                <div class="text">{{ family.spouse_dob || "N/A" }}</div>
              </li>
              <li>
                <div class="table-responsive" style="width: 100%">
                  <table class="table table-nowrap pp-data-table">
                    <thead>
                      <tr>
                        <th class="title">Child's Name</th>
                        <th class="title">Child's DOB</th>
                      </tr>
                    </thead>
                    <tbody v-if="family?.employee_child.length > 0">
                      <tr v-for="child in family.employee_child" :key="child.id">
                        <td class="title">{{ child.child_full_name }}</td>
                        <td class="title">{{ child.child_dob }}</td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td class="text-center" colspan="2">No Data</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </li>
            </ul>
            <div v-if="healthInsuranceEnabled && healthInsurance.length > 0" class="table-responsive"
              style="width: 100%">
              <div class="title mb-2">Health Insurance (Parents)</div>
              <table class="table table-nowrap pp-data-table">
                <tbody>
                  <tr>
                    <th class="title">Relationship</th>
                    <td v-for="item in healthInsurance" :key="item.id" class="title">{{ item.relationship }}</td>
                  </tr>
                  <tr>
                    <th class="title">Parent Name</th>
                    <td v-for="item in healthInsurance" :key="item.id" class="title">{{ item.parent_name }}</td>
                  </tr>
                  <tr>
                    <th class="title">Effective From</th>
                    <td v-for="item in healthInsurance" :key="item.id" class="title">{{ formatDate(item.effective_from) }}</td>
                  </tr>
                  <tr>
                    <th class="title">Effective To</th>
                    <td v-for="item in healthInsurance" :key="item.id" class="title">{{ formatDate(item.effective_to) }}</td>
                  </tr>
                  <tr>
                    <th class="title">Status</th>
                    <td v-for="item in healthInsurance" :key="item.id" class="title text-capitalize">{{ item.status || "N/A" }}</td>
                  </tr>
                  <tr>
                    <th class="title">Monthly Deduction</th>
                    <td v-for="item in healthInsurance" :key="item.id" class="title">{{ formatMoney(item.monthly_deduction) }}</td>
                  </tr>
                  <tr>
                    <th class="title" :colspan="healthInsurance.length">Total Monthly Deduction</th>
                    <td class="title" style="border-bottom: 1px dashed #e4e8ec;">{{ formatMoney(totalMonthlyDeduction) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="pp-card ">
          <div class="pp-header justify-content-start">
            <div class="pp-header-icon"><i class="fa-solid fa-circle-info" aria-hidden="true"></i></div>
            <h3 class="pp-title">Other information</h3>
            <!-- <div class="pp-header-edit-icon">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.47079 2.47059H1.55556C0.696449 2.47059 0 3.208 0 4.11765V12.3529C0 13.2626 0.696449 14 1.55556 14H10.1112C10.9703 14 11.6667 13.2626 11.6667 12.3529V6.32502L8.62269 9.54813C8.35124 9.83554 8.00551 10.0315 7.62909 10.1112L5.54376 10.5528C4.18319 10.8409 2.98362 9.57076 3.25573 8.13016L3.6728 5.92218C3.74808 5.52361 3.93311 5.15756 4.20455 4.87015L6.47079 2.47059Z"
                  fill="#0C090A" fill-opacity="0.66" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M13.1028 1.02541C13.0239 0.823914 12.9083 0.640843 12.7626 0.486661C12.617 0.332377 12.4441 0.209987 12.2538 0.126483C12.0635 0.0429798 11.8595 0 11.6535 0C11.4475 0 11.2435 0.0429798 11.0532 0.126483C10.8629 0.209987 10.69 0.332377 10.5444 0.486661L10.1198 0.93621L12.338 3.28492L12.7626 2.83537C12.9083 2.68119 13.0239 2.49811 13.1028 2.29661C13.1816 2.09511 13.2222 1.87913 13.2222 1.66101C13.2222 1.4429 13.1816 1.22692 13.1028 1.02541ZM11.2381 4.44956L9.01985 2.10086L5.30449 6.03479C5.2502 6.09227 5.2132 6.16548 5.19814 6.24519L4.78108 8.45317C4.72665 8.74129 4.96657 8.99532 5.23868 8.93769L7.324 8.4961C7.39929 8.48015 7.46843 8.44097 7.52272 8.38349L11.2381 4.44956Z"
                  fill="#0C090A" fill-opacity="0.66" />
              </svg>
            </div> -->
          </div>
          <div class="pp-body">
            <ul class="employee-personal-info">
              <li>
                <div class="title">Passport Number</div>
                <div class="text">{{ otherInformation.passport_number }}</div>
              </li>
              <li>
                <div class="title">Passport Expiry Date</div>
                <div class="text">
                  {{ otherInformation.passport_expiry_date }}
                </div>
              </li>
              <li>
                <div class="title">Driving License Number</div>
                <div class="text">
                  {{ otherInformation.driving_license_number }}
                </div>
              </li>
              <li>
                <div class="title">Driving License Expiry Date</div>
                <div class="text">
                  {{ otherInformation.driving_license_expiry_date }}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="pp-card ">
          <div class="pp-header justify-content-start">
            <div class="pp-header-icon"><i class="fa-solid fa-graduation-cap" aria-hidden="true"></i></div>
            <h3 class="pp-title">Education Information</h3>
            <!-- <div class="pp-header-edit-icon">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.47079 2.47059H1.55556C0.696449 2.47059 0 3.208 0 4.11765V12.3529C0 13.2626 0.696449 14 1.55556 14H10.1112C10.9703 14 11.6667 13.2626 11.6667 12.3529V6.32502L8.62269 9.54813C8.35124 9.83554 8.00551 10.0315 7.62909 10.1112L5.54376 10.5528C4.18319 10.8409 2.98362 9.57076 3.25573 8.13016L3.6728 5.92218C3.74808 5.52361 3.93311 5.15756 4.20455 4.87015L6.47079 2.47059Z"
                  fill="#0C090A" fill-opacity="0.66" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M13.1028 1.02541C13.0239 0.823914 12.9083 0.640843 12.7626 0.486661C12.617 0.332377 12.4441 0.209987 12.2538 0.126483C12.0635 0.0429798 11.8595 0 11.6535 0C11.4475 0 11.2435 0.0429798 11.0532 0.126483C10.8629 0.209987 10.69 0.332377 10.5444 0.486661L10.1198 0.93621L12.338 3.28492L12.7626 2.83537C12.9083 2.68119 13.0239 2.49811 13.1028 2.29661C13.1816 2.09511 13.2222 1.87913 13.2222 1.66101C13.2222 1.4429 13.1816 1.22692 13.1028 1.02541ZM11.2381 4.44956L9.01985 2.10086L5.30449 6.03479C5.2502 6.09227 5.2132 6.16548 5.19814 6.24519L4.78108 8.45317C4.72665 8.74129 4.96657 8.99532 5.23868 8.93769L7.324 8.4961C7.39929 8.48015 7.46843 8.44097 7.52272 8.38349L11.2381 4.44956Z"
                  fill="#0C090A" fill-opacity="0.66" />
              </svg>
            </div> -->
          </div>
          <div class="pp-body">
            <ul class="employee-personal-info" v-if="qualificationDetails.length > 0">
              <template v-for="qualification in qualificationDetails"
                :key="qualification.id || qualification.degree_program_name">
                <li>
                  <div class="title">Institute</div>
                  <div class="text">{{ qualification.university_college_name || "N/A" }}</div>
                </li>
                <li>
                  <div class="title">Degree</div>
                  <div class="text">{{ qualification.degree_program_name || "N/A" }}</div>
                </li>
                <li>
                  <div class="title">Duration</div>
                  <div class="text">{{ qualification.degree_start || "N/A" }} - {{ qualification.degree_end || "N/A" }}
                  </div>
                </li>
              </template>
            </ul>
            <ul class="employee-personal-info" v-else>
              <li>
                <div class="title">Education</div>
                <div class="text">N/A</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Separation comments modal -->
    <div class="modal custom-modal fade" id="separation_comments_modal" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Comments</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
              <span data-v-205217b8="" aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <p style="white-space: pre-wrap; word-break: break-word;">{{ positionalInformation.comments }}</p>
          </div>
        </div>
      </div>
    </div>

  </div>
  <!-- /Profile Info Tab -->
</template>

<script>
import MyProfileService from "@/services/MyProfileService";
import { mapGetters } from "vuex";
import { dateFormatter } from "@/utils";

export default {
  data() {
    return {
      healthInsurance: [],
      personalInformation: {},
      positionalInformation: {},
      contractDetails: {},
      qualificationDetails: {},
      otherInformation: {},
      familyInformation: {},
      workExperience: {},
      contactInformation: {},
      emergencyContact: {},
      employmentLevel: {},
      employmentGrade: {},
      contractDetails: {},
      eobi: [
        {
          month: "Aug",
          year: "2024",
          amount: 2000,
        },
      ],
    };
  },
  props: {
    userProfile: {
      type: Object,
      default: {},
    },
  },

  computed: {
    ...mapGetters("system", ["healthInsuranceEnabled"]),

    totalMonthlyDeduction() {
      return this.userProfile?.health_insurance?.total_monthly_deduction;
    },
  },

  methods: {
    formatMoney(value) {
      return Number(value || 0).toLocaleString("en-PK", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    formatDate(date) {
      return date ? dateFormatter(date) : "N/A";
    },
  },

  watch: {
    userProfile: {
      handler() {
        this.healthInsurance = this.userProfile?.health_insurance?.enrolled_parents || [];
        this.personalInformation =
          this.userProfile && this.userProfile.employee_personal_information
            ? this.userProfile.employee_personal_information
            : {};
        this.positionalInformation =
          this.userProfile && this.userProfile.employee_positional_information
            ? this.userProfile.employee_positional_information
            : {};
        this.contractDetails =
          this.userProfile && this.userProfile.employee_contract_detail
            ? this.userProfile.employee_contract_detail
            : {};
        this.qualificationDetails =
          this.userProfile && this.userProfile.employee_qualification
            ? this.userProfile.employee_qualification
            : {};
        this.otherInformation =
          this.userProfile && this.userProfile.employee_other_information
            ? this.userProfile.employee_other_information
            : {};
        this.familyInformation =
          this.userProfile && this.userProfile.employee_family_information
            ? this.userProfile.employee_family_information
            : {};
        this.workExperience =
          this.userProfile && this.userProfile.employee_work_experience
            ? this.userProfile.employee_work_experience
            : {};
        this.contactInformation =
          this.userProfile && this.userProfile.employee_contact_information
            ? this.userProfile.employee_contact_information
            : {};
        this.emergencyContact =
          this.userProfile && this.userProfile.emergency_contact
            ? this.userProfile.emergency_contact
            : {};
        this.employmentLevel =
          this.userProfile && this.userProfile.employment_level
            ? this.userProfile.employment_level
            : {};
        this.employmentGrade =
          this.userProfile && this.userProfile.employment_grade
            ? this.userProfile.employment_grade
            : {};
        this.contractDetails =
          this.userProfile && this.userProfile.employee_contract_detail
            ? this.userProfile.employee_contract_detail
            : {};
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.pp-header-icon {
  width: 45px;
  height: 45px;
  border-radius: 7px;
  background: color-mix(in srgb, var(--primary-color) 15%, #fff);
  color: var(--primary-color);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 0 10px color-mix(in srgb, var(--primary-color) 8%, #fff);
}

.pp-header-icon :deep(svg *) {
  fill: currentColor !important;
  stroke: currentColor !important;
}

.pp-header-icon i {
  font-size: 20px;
  color: currentColor;
}

.pp-card {
  border: 1px solid #d8dde3;
  border-radius: 18px;
  box-shadow: none;
  overflow: hidden;
  background: #fff;
}

.pp-card .pp-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* min-height: 86px; */
  border-bottom: 0;
  background: #fff;
  padding: 30px 30px 20px 20px;
  gap: 12px;
}

.pp-card .pp-header::before {
  content: none;
}

.pp-card .pp-title {
  margin: 0;
  padding-left: 12px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.25;
  color: #12161c;
}

.pp-header-edit-icon {
  width: 30px;
  height: 30px;
  border-radius: 7px;
  background: color-mix(in srgb, var(--primary-color) 10%, #fff);
  color: color-mix(in srgb, var(--primary-color) 14%, #5a5a5f);
  margin-left: auto;
  position: relative;
  flex-shrink: 0;
  box-shadow: 0 0 0 6px color-mix(in srgb, var(--primary-color) 4%, #fff);
  display: flex;
  align-items: center;
  justify-content: center;
}

.pp-header-edit-icon :deep(svg *) {
  fill: currentColor !important;
  stroke: currentColor !important;
}

.pp-card .pp-body {
  padding: 8px 20px 30px;
}

.employee-personal-info li {
  border-bottom: 1px dashed #e4e8ec;
  padding: 12px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.employee-personal-info li:last-child {
  border-bottom: 0;
}

.employee-personal-info .title {
  color: #707783;
  font-size: 12px;
  font-weight: 400;
}

.employee-personal-info .text {
  color: #3e434d;
  font-size: 12px;
  font-weight: 400;
  text-align: right;
}

.section-title {
  margin: 8px 0 10px;
  font-size: 16px;
  color: #12161c;
  font-weight: 600;
}

.table {
  margin-bottom: 0;
}

.table th {
  background: transparent;
  font-size: 12px;
  color: #626a78;
  border: 0;
  border-bottom: 1px dashed #e4e8ec;
  font-weight: 500;
  padding: 10px 0;
}

.table td {
  font-size: 12px;
  color: #3e444f;
  border: 0;
  border-bottom: 1px dashed #e4e8ec;
  padding: 10px 0;
}

.pp-data-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
}

.pp-data-table thead th {
  color: #4c5a78;
  text-align: left;
  padding: 10px 0 12px;
  white-space: nowrap;
}

.pp-data-table tbody td {
  color: #22324f;
  text-align: left;
  padding: 10px 0 0;
}

.table-bordered> :not(caption)>*>* {
  border: 0 !important;
}

.pp-body .table-responsive {
  width: 100%;
}

.pp-body .table tr:last-child td {
  border-bottom: 0;
}

.experience-box,
.experience-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.experience-list li {
  display: flex;
  gap: 10px;
  border-bottom: 1px dashed #e4e8ec;
  padding: 10px 0;
}

.experience-list li:last-child {
  border-bottom: 0;
}

.experience-user {
  width: 10px;
  flex: 0 0 10px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 6px;
}

.before-circle {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: color-mix(in srgb, var(--primary-color) 65%, #fff);
}

.experience-content {
  flex: 1;
  min-width: 0;
}

.timeline-content .name {
  font-size: 12px;
  font-weight: 500;
  color: #3e444f;
  text-decoration: none;
}

.timeline-content div,
.timeline-content .time {
  font-size: 12px;
  color: #707783;
  line-height: 1.5;
}

.pp-body .employee-personal-info .table-responsive {
  margin-top: 2px;
}

.pro-overview .row {
  row-gap: 16px;
}

@media (max-width: 991.98px) {
  .pp-card .pp-body {
    padding: 12px 14px 14px;
  }
}
</style>
